import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TuiIcon, tuiDialog } from '@taiga-ui/core';
import { AuthService } from '../../../auth/services/auth.service';
import { SupportUnreadService } from '../../services/support-unread.service';
import { SupportPanelComponent } from '../support-panel/support-panel.component';

/** Global floating help button; opens the support panel (bottom sheet on mobile via the responsive dialog alias in App). */
@Component({
  selector: 'app-help-button',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TuiIcon],
  templateUrl: './help-button.component.html',
  styleUrl: './help-button.component.less',
})
export class HelpButtonComponent {
  private readonly auth = inject(AuthService);
  private readonly unread = inject(SupportUnreadService);

  protected readonly signedIn = computed(() => !!this.auth.currentUser());
  protected readonly count = this.unread.count;

  private readonly panel = tuiDialog(SupportPanelComponent, {
    size: 'm',
    dismissible: true,
    label: 'Help and feedback',
  });

  protected open(): void {
    this.panel().subscribe();
  }
}
